import { render, staticRenderFns } from "./MergeDuplicateLeadModal.vue?vue&type=template&id=b2f1a51c&scoped=true&"
import script from "./MergeDuplicateLeadModal.vue?vue&type=script&lang=js&"
export * from "./MergeDuplicateLeadModal.vue?vue&type=script&lang=js&"
import style0 from "./MergeDuplicateLeadModal.vue?vue&type=style&index=0&id=b2f1a51c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f1a51c",
  null
  
)

export default component.exports